
import {
  computed,
  defineComponent, onMounted, PropType, Ref, ref,
} from 'vue';
import { useRoute } from 'vue-router';
/* eslint-disable import/no-cycle */
import { useMainStore } from '@/store/mainStore';
import { useMessagesStore } from '@/modules/messages/store/messagesStore';
import { useSpacesStore } from '@/modules/spaces/store/spacesStore';
// import { useRouter } from 'vue-router';
import BottomPopUpItem from '@/components/BottomPopUp/BottomPopUpItem.vue';
import AppBottomPopUp from '@/components/BottomPopUp/AppBottomPopUp.vue';
import { IGroupData, ISpacesContact } from '@/types/interfaces';
import SpacesService from '@/modules/spaces/services/SpacesService';
import { CONTACT_STATUS, GROUP_USER_STATUS } from '@/types/enums';

export default defineComponent({
  props: {
    user: { type: Object as () => ISpacesContact, required: true },
    groupInfo: { type: Object as PropType<IGroupData>, required: true },
    currentUserIsAdmin: { type: Boolean, default: false },
  },
  components: {
    BottomPopUpItem,
    AppBottomPopUp,
  },
  emits: ['hide', 'on-user-update', 'close-group-info'],
  setup(props, { emit }) {
    const mainStore = useMainStore();
    const messagesStore = useMessagesStore();
    const spacesStore = useSpacesStore();
    const route = useRoute();
    const navigation: Ref<HTMLElement | null> = ref(null);
    const showNavigation: Ref<boolean> = ref(false);

    const userFullName = computed(() => `${props.user.firstName} ${props.user.lastName}`);

    function setAsAdmin() {
      const payload = {
        groupId: props.groupInfo.id,
        userId: props.user.accountId,
        type: 'Admin',
      };
      SpacesService.updateUserStatus(payload).then((response) => {
        if (response.success) {
          // close popup (emit) + update data in users list
          emit('on-user-update');
        }
      });
    }

    function revokeAdmin() {
      const payload = {
        groupId: props.groupInfo.id,
        userId: props.user.accountId,
        type: 'User',
      };
      SpacesService.updateUserStatus(payload).then((response) => {
        if (response.success) {
          emit('on-user-update');
        }
      });
    }

    /** Removes the specified user from the list of members of the group with the specified ID in the spacesStore cache. */
    function removeUserFromGroupCache(groupId: string, userId: string) {
      const currentGroup = spacesStore.myGroups.find((group) => group.id === groupId);
      if (currentGroup) {
        currentGroup.members = currentGroup.members.filter((member) => member.accountId !== userId);
      }
    }

    function removeUser() {
      SpacesService.deleteUserFromGroup(props.groupInfo.id, props.user.accountId).then((response) => {
        if (response.success) {
          removeUserFromGroupCache(props.groupInfo.id, props.user.accountId);
          emit('on-user-update');
        }
      });
    }

    function requestContact() {
      SpacesService.requestContact(props.user.accountId).then(() => {
        const currentMember = messagesStore.currentConversation?.group?.members.find((item) => item.accountId === props.user.accountId);
        currentMember!.contactStatus = CONTACT_STATUS.REQUEST_SENT;
      });
      // emit('hide');
    }

    function fetchGroupData() {
      // SpacesService.getGroupById(route.params.id as string).then((response) => {
      //   if (response.success) {
      //     groupInfo.value = response.results.data;
      //   }
      //   // TODO add error handling (404)
      // });
    }
    onMounted(() => {
      fetchGroupData();
    });

    return {
      mainStore,
      navigation,
      showNavigation,
      userFullName,
      emit,
      GROUP_USER_STATUS,
      CONTACT_STATUS,
      setAsAdmin,
      revokeAdmin,
      removeUser,
      requestContact,
    };
  },
});
